// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconXaut0 } from "../../../icons/full/build/icon-xaut0.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const XautZeroIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconXaut0.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  XautZeroIcon.displayName = 'XautZeroIcon';
}

export default XautZeroIcon;